<template>
  <button
    v-bind="$attrs"
    :class="buttonClasses"
    :disabled="disabled"
    :type="type"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <IconBase :icon="icon" :tone="currentIconTone" :size="iconBaseSize" />
  </button>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import IconBase from "@/elements/UI/icon/IconBase.vue";
import style from "./ButtonIcon.module.scss";

export default defineComponent({
  name: "ButtonIcon",
  inheritAttrs: false,
  components: {IconBase},
  props: {
    icon: {
      type: String,
      required: true
    },
    variant: {
      type: String as PropType<ButtonIconColor>,
      default: "subtle"
    },
    size: {
      type: [String, Number] as PropType<ButtonIconSizes | number>,
      default: "24"
    },
    iconTone: {
      type: String as PropType<IconTone>,
      default: "default"
    },
    // experimental function !!! don't delete !!!
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<ButtonTypeClick>,
      default: "button"
    }
  },
  data() {
    return {
      isHovered: false
    };
  },
  computed: {
    normalizedSize(): "24" | "28" {
      return String(this.size) === "28" ? "28" : "24";
    },
    buttonClasses(): string[] {
      return [
        style.buttonIcon,
        style[this.variant],
        style[`size${this.normalizedSize}`],
        this.active ? style.active : "",
        this.disabled ? style.disabled : ""
      ];
    },
    iconBaseSize(): Size {
      return this.normalizedSize === "24" ? "S" : "M";
    },
    currentIconTone(): IconTone {
      if (this.disabled) {
        return "disabled";
      }

      if (this.active || this.isHovered) {
        return "default";
      }

      return this.variant === "ghost" ? "default" : "tertiary";
    }
  },
  methods: {
    handleMouseEnter(): void {
      if (this.disabled) return;
      this.isHovered = true;
    },
    handleMouseLeave(): void {
      this.isHovered = false;
    }
  }
});
</script>
